import { bool, func, object, string } from "prop-types";

import styled from "styled-components";

import FnrOpacityToggle from "UI/FnrOpacityToggle";

import Input from "./Input";
import ToggleOn from "./ToggleOn";

const ToggleOnOpacity = styled(FnrOpacityToggle)`
  width: 0;
`;

const InputOpacity = styled(FnrOpacityToggle)`
  width: 100%;
`;

const SuperSearch = ({ isActive, setIsActive, toggleRef, value, setValue }) => {
  return (
    <>
      <ToggleOnOpacity show={!isActive}>
        <ToggleOn setIsActive={setIsActive} toggleRef={toggleRef} />
      </ToggleOnOpacity>
      <InputOpacity show={isActive}>
        <Input
          isActive={isActive}
          setIsActive={setIsActive}
          toggleRef={toggleRef}
          value={value}
          setValue={setValue}
        />
      </InputOpacity>
    </>
  );
};

SuperSearch.propTypes = {
  isActive: bool.isRequired,
  setIsActive: func.isRequired,
  toggleRef: object,
  value: string.isRequired,
  setValue: func.isRequired,
};

export default SuperSearch;
